import { render, staticRenderFns } from "./BlogComponent.vue?vue&type=template&id=1fb96ee6&scoped=true&"
import script from "./BlogComponent.vue?vue&type=script&lang=js&"
export * from "./BlogComponent.vue?vue&type=script&lang=js&"
import style0 from "./BlogComponent.vue?vue&type=style&index=0&id=1fb96ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb96ee6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VImg,VRow,VSkeletonLoader})
